export default __webpack_public_path__ + "static/media/mens.2b5e1e6e.jpg";